import React from "react";

export default class TabsSteps extends React.Component {
  static defaultProps = {
    stepCount: 5,
    renderStepContent: (stepNum) => "Step " + stepNum,
    activeStep: 1,
  };

  renderSteps = () => {
    const steps = [];

    for (let i = 1; i <= this.props.stepCount; i++) {
      steps.push(
        <li
          className={
            this.props.activeStep == i
              ? "is-active"
              : this.props.activeStep > i
              ? "is-completed"
              : ""
          }
        >
          <a>{this.props.renderStepContent(i)}</a>
        </li>
      );
    }

    return steps;
  };

  render() {
    return (
      <div className="tabs tabs-steps only-mobile">
        <ul>{this.renderSteps()}</ul>
      </div>
    );
  }
}
